var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypesymbolstyledefaultstatedefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94581 19.1047C9.94581 19.2841 10.1001 19.4286 10.2903 19.4286C10.376 19.4286 10.472 19.3787 10.544 19.3289L10.5543 19.3223L14.7606 16.0636L10.5817 12.1804C10.3246 11.9795 9.94066 12.1555 9.94066 12.3997L9.94067 14.6578C9.94067 15.0215 9.55671 15.088 9.27732 14.98L8.5334 14.7143C8.50598 14.7043 8.47685 14.6927 8.45285 14.6761C8.25744 14.5449 8.17345 14.3157 8.17345 14.1164L8.17345 7.15127C8.17345 6.69453 8.55569 6.32415 9.02706 6.32415H13.0397C14.1504 6.3308 15.7925 7.16788 15.7925 9.00317C15.7925 9.35528 15.7445 9.82697 15.6691 10.0877C15.5063 10.6425 15.2132 11.0627 14.9526 11.2935C14.2036 11.9529 13.3585 11.9595 13.0774 11.9446L12.9026 11.9413L16.209 14.906C17.3986 13.6669 18.0928 11.9961 17.99 10.1708C17.8066 6.91211 15.0418 4.2497 11.5965 4.01718C9.92352 3.90424 8.36714 4.35434 7.11587 5.1881C6.40795 5.6598 6 6.43875 6 7.25757V13.8031C6 14.6269 6.41652 15.4042 7.13129 15.8759C7.87691 16.3692 8.57969 16.7047 9.50186 16.8891C9.7864 16.9455 9.93723 17.1249 9.93723 17.5119",
    fill: "url(#paint0_linear_237_8893)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0175 10.1459C13.0998 10.1459 13.3912 10.1127 13.5883 9.93328C13.7374 9.79875 13.8522 9.57619 13.8522 9.22906C13.8522 8.35709 13.3637 8.15114 12.9524 8.13287H10.2578C10.0401 8.13287 9.86359 8.30395 9.86359 8.51488V9.76553C9.86359 9.97646 10.0401 10.1475 10.2578 10.1475H12.9232L13.0192 10.1459H13.0175Z",
    fill: "url(#paint1_linear_237_8893)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_237_8893",
    x1: 4.74061,
    y1: 4.60963,
    x2: 15.4465,
    y2: 15.6561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8459FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5143E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_237_8893",
    x1: 9.44498,
    y1: 8.21248,
    x2: 10.3752,
    y2: 10.6556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8459FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5143E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypesymbolstyledefaultstatedefault);
export default __webpack_public_path__ + "static/media/type=symbol, style=default, state=default.a509f57cd96130f483745034715c8482.svg";
export { ForwardRef as ReactComponent };